import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ProviderFieldComponent } from './provider-field.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
  ],
  declarations: [
    ProviderFieldComponent,
  ],
  exports: [
    ProviderFieldComponent,
  ],
})
export class ProvidersExportModule {}
